import ObjectId from 'bson-objectid';
import { Button, Col, Dropdown, Input, Row, Text } from 'components';
import { Api, sports, validateEmail } from 'lib';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Image } from 'screens/Admin/components';
import styled from 'styled-components';

const StyledDropdown = styled(Dropdown)`
  p  {
    margin: 0 19px;
  }
`;

const CreateUser = ({ callback }) => {
  const [name, setName] = useState(''),
    [username, setUsername] = useState(''),
    [email, setEmail] = useState(''),
    [password, setPassword] = useState(''),
    [sport, setSport] = useState(''),
    [type, setType] = useState('Athlete'),
    [avatar, setAvatar] = useState(null),
    [loading, setLoading] = useState(false),
    [errs, setErrs] = useState([]),
    isMobile = useSelector((state) => state.appState.isMobile),
    navigate = useNavigate(),
    dispatch = useDispatch();

  async function submit() {
    setErrs([]);
    const newErrs = [];
    if (!name) newErrs.push({ input: 'name', err: 'Required' });
    if (!username) newErrs.push({ input: 'username', err: 'Required' });
    if (!email) newErrs.push({ input: 'email', err: 'Required' });
    if (email && !validateEmail(email)) errs.push({ input: 'email', err: 'Not a valid email' });
    if (!sport) newErrs.push({ input: 'sport', err: 'Required' });
    if (!type) newErrs.push({ input: 'type', err: 'Required' });
    if (!password) newErrs.push({ input: 'password', err: 'Required' });

    if (newErrs.length) {
      setErrs(newErrs);

      return;
    }

    let data = new FormData();

    data.append('name', name);
    data.append('username', username);
    data.append('email', email);
    data.append('sports', JSON.stringify([{ sport }]));
    data.append('password', password);
    data.append('type', type.toLowerCase());

    if (avatar) {
      const avatarId = ObjectId().toString();
      data.append('avatar', avatar[1], `${avatarId}-avatar.jpeg`);
      data.append('fileName', `${avatarId}-avatar.jpeg`);
    }

    const res = await Api.post('/admin/createUser', data, 'createUser');
    if (!res) return console.log('Something went wrong!');

    setName('');
    setUsername('');
    setEmail('');
    setPassword('');
    setSport('');
    setType('Athlete');
    setAvatar('');

    dispatch({
      type: 'HANDLE_RES',
      payload: { res: 'User created succesfully' }
    });

    callback(res);
  }

  function handleInputChange(input, callback) {
    setErrs(errs.filter((x) => x.input !== input));
  }

  return (
    <Col>
      <Row between center noFlex ht={isMobile ? '44px' : '88px'}>
        <Text size="30px" med>
          ADD USER
        </Text>
      </Row>

      <Input
        onChange={({ target }) => {
          setName(target.value);
          handleInputChange('name');
        }}
        value={name}
        marg="0 0 20px"
        placeholder="Name"
        title="Name"
        rounded
        bg="#fff"
        error={errs.find((x) => x.input === 'name')?.err}
      />

      <Input
        onChange={({ target }) => {
          setUsername(target.value);
          handleInputChange('username');
        }}
        value={username}
        marg="0 0 20px"
        placeholder="Username"
        title="Username"
        rounded
        bg="#fff"
        error={errs.find((x) => x.input === 'username')?.err}
      />

      <Input
        onChange={({ target }) => {
          setEmail(target.value);
          handleInputChange('email');
        }}
        value={email}
        marg="0 0 20px"
        placeholder="Email"
        title="Email"
        rounded
        bg="#fff"
        error={errs.find((x) => x.input === 'email')?.err}
      />

      <StyledDropdown
        admin
        handleSelect={(e) => {
          setSport(e.name);
          handleInputChange('sport');
        }}
        options={sports}
        selected={sport}
        placeholder="Sport"
        title="Sport"
        bg="#fff"
        marg="0 0 20px"
        rounded
        wid="100%"
        error={errs.find((x) => x.input === 'sport')?.err}
      />

      <StyledDropdown
        admin
        handleSelect={(e) => {
          setType(e);
          handleInputChange('type');
        }}
        options={['Athlete', 'Team', 'Fan']}
        selected={type}
        placeholder="Type"
        title="User type"
        bg="#fff"
        marg="0 0 20px"
        rounded
        wid="100%"
        error={errs.find((x) => x.input === 'type')?.err}
      />

      <Input
        onChange={({ target }) => {
          setPassword(target.value);
          handleInputChange('password');
        }}
        value={password}
        marg="0 0 20px"
        placeholder="Password"
        title="Password"
        rounded
        password
        bg="#fff"
        error={errs.find((x) => x.input === 'password')?.err}
      />

      <Col minWid="250px" marg="0 0 0 20px">
        <Text med size="22px">
          Profile picture
        </Text>

        <Image imgs={avatar} setImgs={(data) => setAvatar(data)} />
      </Col>

      <Col center wid="100%">
        <Button text="Create" wid="100%" marg="20px 0 0" onClick={submit} action="createUser" />
      </Col>
    </Col>
  );
};

export default CreateUser;
